export class AzureSecurityGroupTransformer {
  normalizeSecurityGroup() {}
}
